<template>
  <p>HTTP401 - denied</p>
</template>

<script setup>


</script>
